// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g6-0";
export var animationContainer = "_g6-1";
export var modalContent = "_g6-2";
export var orderName = "_g6-3";
export var refundOption = "_g6-4";
export var refundOptionsContainer = "_g6-5";